module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/bg_white_bg_note-9f9908e6cc9208a7becfd5902c04e9c1.jpg";